import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAdminAuth } from "@/admin/AdminAuthContext";
import { toast } from "sonner";
import { LogIn, Loader2 } from "lucide-react";
import { ASSETS } from "@/lib/api";

export default function AdminLogin() {
  const { login, user } = useAdminAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user) navigate("/admin", { replace: true });
  }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Bem-vindo de volta");
      navigate("/admin", { replace: true });
    } catch (err) {
      const detail = err?.response?.data?.detail;
      toast.error(typeof detail === "string" ? detail : "Credenciais inválidas");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0B0B0B] text-white grid lg:grid-cols-2" data-testid="admin-login-page">
      <div className="hidden lg:block relative overflow-hidden">
        <img
          src="https://images.pexels.com/photos/29459994/pexels-photo-29459994.jpeg?auto=compress&cs=tinysrgb&w=1600"
          alt=""
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-[#0B0B0B]/70 via-[#0B0B0B]/40 to-[#0B0B0B]/85" />
        <div className="absolute bottom-14 left-14 right-14">
          <img src={ASSETS.logoMark} alt="ROTTA" className="h-14 w-auto mb-6" />
          <h1 className="font-display text-4xl leading-tight text-white">
            Painel <span className="text-gold-gradient">ROTTA</span>
          </h1>
          <p className="text-[#B8B8B8] mt-3 max-w-sm">
            Gerencie rotas, cidades, eventos e blog. Todo o conteúdo publicado aparece no site
            automaticamente.
          </p>
        </div>
      </div>

      <div className="flex items-center justify-center p-8">
        <form onSubmit={submit} className="w-full max-w-md space-y-5" data-testid="admin-login-form">
          <div className="lg:hidden flex items-center gap-3 mb-8">
            <img src={ASSETS.logoMark} alt="ROTTA" className="h-10 w-auto" />
            <div className="flex flex-col leading-none">
              <span className="font-display text-lg tracking-wider">ROTTA</span>
              <span className="text-[10px] tracking-[0.3em] text-[#C6A762]">PAINEL ADMIN</span>
            </div>
          </div>

          <div>
            <div className="flex items-center gap-3 text-[#C6A762] mb-3">
              <span className="gold-divider" />
              <span className="text-[11px] tracking-[0.35em] uppercase">Acesso restrito</span>
            </div>
            <h2 className="font-display text-3xl">Entrar no painel</h2>
            <p className="text-[#B8B8B8] mt-2 text-sm">Use suas credenciais de administrador.</p>
          </div>

          <div>
            <label className="text-[11px] tracking-[0.2em] uppercase text-[#B8B8B8] block mb-2">E-mail</label>
            <input
              data-testid="login-email"
              type="email" required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="input-rotta"
              placeholder="admin@rotta.com.br"
              autoComplete="email"
            />
          </div>

          <div>
            <label className="text-[11px] tracking-[0.2em] uppercase text-[#B8B8B8] block mb-2">Senha</label>
            <input
              data-testid="login-password"
              type="password" required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="input-rotta"
              placeholder="••••••••"
              autoComplete="current-password"
            />
          </div>

          <button
            data-testid="login-submit"
            disabled={loading}
            type="submit"
            className="btn-gold w-full py-4 rounded-full text-xs inline-flex items-center justify-center gap-2 disabled:opacity-60"
          >
            {loading ? <Loader2 size={14} className="animate-spin" /> : <LogIn size={14} />}
            {loading ? "Entrando…" : "Entrar"}
          </button>
        </form>
      </div>
    </div>
  );
}
